// Actions
import type { ShowroomSectionKey } from '@makemydeal/dr-sales-checkin-types';
import { Actions } from '../actionTypes/actionTypes';

export const setHamburgerVisibility = (isVisible: boolean) => {
    return {
        type: Actions.SET_HAMBURGER_VISIBILITY,
        payload: isVisible
    };
};

export const setActiveSection = (key: ShowroomSectionKey) => {
    return {
        type: Actions.SET_ACTIVE_SECTION,
        payload: key
    };
};

export const activateSection = (sectionKey: ShowroomSectionKey) => {
    return {
        type: Actions.ACTIVATE_SECTION,
        payload: { sectionKey }
    };
};
